/* tag : v1.0.0 */
!(function (t, e) {
  if ("object" == typeof exports && "object" == typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    var r = e();
    for (var n in r) ("object" == typeof exports ? exports : t)[n] = r[n];
  }
})(window, function () {
  return (function (t) {
    var e = {};
    function r(n) {
      if (e[n]) return e[n].exports;
      var i = (e[n] = { i: n, l: !1, exports: {} });
      return t[n].call(i.exports, i, i.exports, r), (i.l = !0), i.exports;
    }
    return (
      (r.m = t),
      (r.c = e),
      (r.d = function (t, e, n) {
        r.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
      }),
      (r.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (r.t = function (t, e) {
        if ((1 & e && (t = r(t)), 8 & e)) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (
          (r.r(n),
          Object.defineProperty(n, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var i in t)
            r.d(
              n,
              i,
              function (e) {
                return t[e];
              }.bind(null, i)
            );
        return n;
      }),
      (r.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return r.d(e, "a", e), e;
      }),
      (r.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (r.p = "/"),
      r((r.s = 5))
    );
  })([
    function (t, e) {
      t.exports = require("jquery");
    },
    function (t, e, r) {
      "use strict";
      r.r(e);
      /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
      var n = function (t, e) {
        return (n =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (t, e) {
              t.__proto__ = e;
            }) ||
          function (t, e) {
            for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
          })(t, e);
      };
      var i = r(0),
        o = r.n(i),
        c = [
          "--",
          "Ⅰ",
          "Ⅱ",
          "Ⅲ",
          "Ⅳ",
          "Ⅴ",
          "Ⅵ",
          "Ⅶ",
          "Ⅷ",
          "Ⅸ",
          "Ⅹ",
          "一",
          "二",
          "三",
          "四",
          "五",
          "六",
          "七",
          "八",
          "九",
          "十",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "VI",
          "VII",
          "VIII",
          "IX",
          "X",
        ],
        l = (function () {
          function t() {
            (this.config = {
              el: "",
              timestampRegExp: /\[\d*:\d*((\.|\:)\d*)*\]/g,
              itemTag: "li",
              interlacedReplace: "&nbsp;",
              interlacedClassName: "interlaced",
              fromClass: "from",
              fixBreakLine: !1,
              lrcLoadTimeout: 5e3,
              lrcCleanUp: o.a.noop,
              detectInterlaced: o.a.noop,
              detectFrom: o.a.noop,
            }),
              (this.$el = o()()),
              (this.$eventEl = o()()),
              (this.lrcObject = {}),
              (this.loading = !1);
          }
          return (
            (t.prototype.generator_lrc_html = function () {
              for (
                var t = "",
                  e = o.a.map(this.lrcObject, function (t, e) {
                    return e;
                  }),
                  r = 0;
                r < e.length;
                r++
              ) {
                var n = e[r];
                if (this.lrcObject[n].hide) break;
                var i = this.lrcObject[n].clause,
                  l = "";
                ~c.indexOf(i.trim())
                  ? ((i = "--" === i ? this.config.interlacedReplace : i),
                    (l = this.config.interlacedClassName),
                    (this.lrcObject[n].interlaced = !0))
                  : (this.lrcObject[n].interlaced = !1),
                  this.lrcObject[n].isFrom && (l = this.config.fromClass);
                var a = l ? 'class="' + l + '"' : "";
                t +=
                  "<" +
                  this.config.itemTag +
                  ' data-seconds="' +
                  n +
                  '" data-index="' +
                  r +
                  '" ' +
                  a +
                  ">" +
                  i +
                  "</" +
                  this.config.itemTag +
                  ">";
              }
              this.$el.html(t);
            }),
            (t.prototype.fix_lrc_title_break_line = function () {
              var t = o.a.map(this.lrcObject, function (t) {
                  return t;
                }),
                e = t.find(function (t) {
                  return t.isFrom;
                }),
                r = t.indexOf(e),
                n = o.a.map(this.lrcObject, function (t, e) {
                  return e;
                })[r];
              if (e && t.length - 1 > r) {
                for (
                  var i = "", c = t.slice(r), l = 0;
                  l < c.length && "--" !== c[l].clause;
                  l++
                )
                  i += c[l].clause;
                this.lrcObject[n].clause = i;
                var a = o.a.map(this.lrcObject, function (t, e) {
                  return e;
                });
                for (
                  l = r + 1;
                  l < t.length && "--" !== this.lrcObject[a[l]].clause;
                  l++
                )
                  this.lrcObject[a[l]].hide = !0;
              }
            }),
            (t.prototype.lrc_text_format = function (t) {
              var e = this,
                r = {};
              /]\[/.test(t) && (t = t.replace(/([^\n])\[/g, "$1\n[")),
                (t = (t = t.replace(/\r|\r\n|\n\r/g, ""))
                  .replace(/\[ar:.*?]/, "")
                  .replace(/\[ti:.*?]/, "")
                  .replace(/\[al:.*?]/, "")
                  .replace(/\[length:.*?]/, ""));
              var n = this.config.lrcCleanUp(t);
              t = (t = n || t)
                .split("\n")
                .filter(function (t) {
                  return (
                    0 !== t.trim().length &&
                    !!t.trim().match(e.config.timestampRegExp)
                  );
                })
                .join("\n");
              var i = 0;
              return (
                t.split("\n").map(function (t) {
                  var n = t.match(e.config.timestampRegExp),
                    o = t.replace(e.config.timestampRegExp, "").trim();
                  if (n) {
                    var c = n[0].match(/(\d{1,2}):(\d{1,2})\.(\d{1,2})/);
                    if (c) {
                      var l =
                          Number(60 * Number(c[1]) + Number(c[2])) + "." + c[3],
                        a = e.config.detectFrom(o);
                      r[l] = {
                        index: i++,
                        clause: r[l]
                          ? r[l].text + '<span class="br"></span>' + o
                          : o,
                        isFrom: a,
                        hide: !1,
                      };
                    }
                  }
                }),
                r
              );
            }),
            t
          );
        })(),
        a = "init",
        u = "lrcLoadStart",
        f = "lrcLoaded",
        s = "lrcLoadError",
        p = (function (t) {
          function e(e) {
            var r = t.call(this) || this;
            return (
              (r.currentToken = 0),
              (r.config = o.a.extend({}, r.config, e)),
              (r.$el = o()(r.config.el)),
              (r.$eventEl = o()("<div/>")),
              r.$eventEl.trigger(a),
              r
            );
          }
          return (
            (function (t, e) {
              function r() {
                this.constructor = t;
              }
              n(t, e),
                (t.prototype =
                  null === e
                    ? Object.create(e)
                    : ((r.prototype = e.prototype), new r()));
            })(e, t),
            (e.prototype.check = function (t) {
              var e = o.a.map(this.lrcObject, function (t, e) {
                  return e;
                }),
                r = e.find(function (e) {
                  return Number(e) > Number(t);
                });
              if (r) {
                var n = e[e.indexOf(r) - 1];
                if (n) return this.lrcObject[n];
              } else if (Number(t) > Number(e[e.length - 1]))
                return this.lrcObject[e[e.length - 1]];
              return null;
            }),
            (e.prototype.load = function (t) {
              var e = this,
                r = Math.ceil(1e6 * Math.random());
              return (
                (this.currentToken = r),
                this.$eventEl.trigger(u, [t]),
                this.load_remote_lrc(t, r).then(
                  function (t) {
                    t[1] == e.currentToken &&
                      ((e.lrcObject = e.lrc_text_format(t[0])),
                      e.config.fixBreakLine && e.fix_lrc_title_break_line(),
                      e.generator_lrc_html(),
                      e.generator_lrc_title(),
                      e.$eventEl.trigger(f, [t[0], e.lrcObject]));
                  },
                  function (t) {
                    t[1] == e.currentToken && e.$eventEl.trigger(s, [t[0]]);
                  }
                ),
                this
              );
            }),
            (e.prototype.load_promise = function (t) {
              var e = this;
              return new Promise(function (r, n) {
                e.load(t),
                  e.$eventEl.one(f, function (t, e, n) {
                    return r({ lrcText: e, lrcObject: n });
                  }),
                  e.$eventEl.one(s, function (t, e) {
                    return n(e);
                  });
              });
            }),
            (e.prototype.destroy = function () {
              this.$eventEl.remove(), this.$el.html(""), this.$el.remove();
            }),
            (e.prototype.on = function (t, e) {
              return this.$eventEl.on(t, e), this;
            }),
            (e.prototype.one = function (t, e) {
              return this.$eventEl.one(t, e), this;
            }),
            (e.prototype.off = function (t) {
              return this.$eventEl.off(t), this;
            }),
            (e.prototype.generator_lrc_title = function () {
              var t = this.$el.children().eq(0);
              t.nextUntil("." + this.config.interlacedClassName)
                .add(t)
                .addClass("lrc-title");
            }),
            (e.prototype.load_remote_lrc = function (t, e) {
              var r = this;
              return (
                void 0 === e && (e = 0),
                new Promise(function (n, i) {
                  o.a
                    .ajax({
                      dataType: "text",
                      method: "GET",
                      timeout: r.config.lrcLoadTimeout,
                      url: t,
                    })
                    .then(
                      function (t) {
                        return n([t, e]);
                      },
                      function (t) {
                        return i([t, e]);
                      }
                    );
                })
              );
            }),
            e
          );
        })(l);
      e.default = p;
    },
    ,
    ,
    ,
    function (t, e, r) {
      t.exports = r(1);
    },
  ]);
});
